<template>
  <div>
    <el-form ref="form" :model="newForm" size="mini">
      <el-row :gutter="10" class="head_text">
        <el-col :span="12">
          <div>{{ $l('form_original_information') || '原信息内容' }}</div>
        </el-col>
        <el-col :span="12">
          <div>{{ $l('form_information_after_change') || '变更信息内容' }}</div>
        </el-col>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_paymentTerms') || '默认付款条件'"
          >
            <el-input v-model="formData.paymentTerms" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_paymentTerms') || '默认付款条件'"
            prop="paymentTerms"
          >
            <el-input
              v-if="newForm.v_paymentTerms"
              v-model="newForm.v_paymentTerms"
              readonly
              :flag="'flag'"
            />
            <el-input v-else v-model="formData.paymentTerms" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_discountSalesAmount') || '货款结算是否包含佣金'
            "
          >
            <el-input v-model="formData.discountSalesAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_discountSalesAmount') || '货款结算是否包含佣金'
            "
            prop="discountSalesAmount"
          >
            <el-input
              v-if="newForm.v_discountSalesAmount"
              v-model="newForm.v_discountSalesAmount"
              readonly
              :flag="'flag'"
            />
            <el-input v-else v-model="formData.discountSalesAmount" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> </el-row>
    </el-form>

    <div class="pt-3 pb-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <h6 class="m-0">
            {{ $l('form_header_takeOrder') || '接单抬头设置' }}
          </h6>
        </div>
      </div>

      <div class="cust-takeOrder-list">
        <el-form
          v-for="(form, index) in newTakeOrderList"
          :key="index"
          ref="takeOrderForm"
          :model="form"
          size="mini"
          label-position="top"
          disabled
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderOrgCode') || '接单抬头设置'"
              >
                <span>{{ form.takeOrderOrgName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderType') || '订单类型限制'"
              >
                <span>{{ form.v_takeOrderType }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_executeOrgCode') || '国内业务执行公司'"
              >
                <span>{{ form.executeOrgName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <EmptyContent v-if="!newTakeOrderList || !newTakeOrderList.length" />
      </div>
    </div>

    <el-form ref="formChange" :model="newForm" size="mini">
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{
                  $l('form_label_reason_change_explanation') || '变更原因说明'
                }}
              </span>
            </h6>
          </div>
          <el-form-item prop="remark">
            <div>
              <el-input
                v-model="newForm.remark"
                type="textarea"
                :rows="6"
                :maxlength="500"
                show-word-limit
                clearable
                readonly
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import EmptyContent from '../empty-content'
// import { cloneDeep } from 'lodash'
export default {
  components: { EmptyContent },
  props: {
    formData: { type: Object, default: () => {} },
  },
  data() {
    return {
      newForm: {},
      newTakeOrderList: [],
    }
  },
  computed: {},
  watch: {
    formData: {
      handler() {
        if (this.formData && this.formData.updateContent) {
          this.newForm = JSON.parse(this.formData.updateContent)
          this.newTakeOrderList = this.newForm.newTakeOrderList
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-input .el-input__inner[readonly='readonly'] {
    background-color: #f9f9f9;
    border: none !important;
  }
  .el-input .el-input__inner[flag='flag'] {
    color: red;
  }
}
.head_text {
  color: #101010;
  font-size: 16px;
  font-weight: 600;
}

::v-deep {
  .cust-takeOrder-list {
    .el-form {
      background-color: #f9f9f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
